export default __webpack_public_path__ + "tmp_src/components/ProductAccordion/ProductAccordion.css.liquid";